import { render } from "./WebDevelopmentPage.vue?vue&type=template&id=2dcf6373"
import script from "./WebDevelopmentPage.vue?vue&type=script&lang=js"
export * from "./WebDevelopmentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__